import { Seo } from "../components/Seo";
import { Reveal } from "../components/Reveal";
import { RoomCard } from "../components/RoomCard";
import { CTABand } from "../components/CTABand";
import { useLang } from "../i18n";

export default function Camere() {
  const { data, t } = useLang();
  const { ROOMS } = data;
  const p = t.roomsPage;

  return (
    <>
      <Seo title={p.seo.title} description={p.seo.description} path="/camere" />
      <section className="max-w-7xl mx-auto px-5 md:px-10 pt-32 md:pt-44 pb-14 md:pb-20">
        <Reveal>
          <p className="eyebrow mb-5">{p.eyebrow}</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-tight text-ink max-w-3xl">
            {p.h1}
          </h1>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-8 text-base md:text-lg text-body leading-relaxed max-w-2xl">
            {p.lead}
          </p>
        </Reveal>
      </section>
      <section className="max-w-7xl mx-auto px-5 md:px-10 pb-20 md:pb-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          <Reveal className="md:col-span-7"><RoomCard room={ROOMS[0]} /></Reveal>
          <Reveal delay={0.08} className="md:col-span-5"><RoomCard room={ROOMS[1]} tall /></Reveal>
          <Reveal className="md:col-span-5"><RoomCard room={ROOMS[2]} tall /></Reveal>
          <Reveal delay={0.08} className="md:col-span-7"><RoomCard room={ROOMS[3]} /></Reveal>
        </div>
        <Reveal delay={0.1}>
          <div className="mt-14 border border-sand bg-surface p-8 md:p-10">
            <h2 className="font-serif text-2xl md:text-3xl text-ink">{p.boxTitle}</h2>
            <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-3 text-sm md:text-base text-body">
              {p.boxItems.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        </Reveal>
      </section>
      <CTABand title={p.ctaTitle} text={p.ctaText} />
    </>
  );
}
